import React, { useState, useEffect } from 'react';
import BrochureModal from './BrochureModal';
import './Navigation.css';

const Navigation = ({ config, alwaysScrolled = false }) => {
  const [isScrolled, setIsScrolled] = useState(alwaysScrolled);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      if (!alwaysScrolled) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        setIsScrolled(scrollTop > 50);
      }
    };

    if (!alwaysScrolled) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [alwaysScrolled]);

  // 管理移动菜单打开时的body滚动
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [isMobileMenuOpen]);

  // 监听窗口大小变化，防止菜单闪烁
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 900;
      if (!isMobile && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isMobileMenuOpen]);

  // 监听页面变化
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#why-nexus') {
        setCurrentPage('why-nexus');
      } else if (hash === '#contact') {
        setCurrentPage('contact');
      } else {
        setCurrentPage('home');
      }
    };

    // 初始检查
    handleHashChange();

    // 监听hash变化
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <div className={`navigation ${isScrolled ? 'scrolled' : ''} page-${currentPage}`}>
      <div className="navigation-content">
        <div 
          className="logo"
          onClick={() => {
            window.location.hash = '#home';
            setIsMobileMenuOpen(false);
          }}
          style={{ cursor: 'pointer' }}
        >
          <img 
            src={config.logo} 
            alt="Nexus Living Logo" 
            className={`logo-icon ${isScrolled ? 'scrolled' : ''}`}
          />
          <img 
            src={config.logoDark} 
            alt="Nexus Living Logo" 
            className={`logo-icon dark ${isScrolled ? 'visible' : ''}`}
          />
          <img 
            src={config.logoMobile} 
            alt="Nexus Living Logo Mobile" 
            className={`logo-icon mobile ${isScrolled ? 'visible' : ''}`}
          />
        </div>
        
        <nav className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          {config.menuItems.map((item, index) => {
            const isActive = (item.href === '#home' && currentPage === 'home') || 
                           (item.href === '#why-nexus' && currentPage === 'why-nexus') ||
                           (item.href === '#contact' && currentPage === 'contact');
            return (
              <a 
                key={index}
                href={item.href} 
                className={`nav-link ${isActive ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            );
          })}
          
          <div className="mobile-download-button">
            <button 
              className="download-btn mobile"
              onClick={() => {
                setIsModalOpen(true);
                setIsMobileMenuOpen(false);
              }}
            >
              <span>{config.downloadButton.text}</span>
            </button>
          </div>
        </nav>
        
        <div className="download-button desktop-only">
          <button 
            className="download-btn"
            onClick={() => setIsModalOpen(true)}
          >
            <span>{config.downloadButton.text}</span>
          </button>
        </div>
        
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <img 
            src={isMobileMenuOpen ? "/images/icons/close-icon.svg" : "/images/icons/menu-icon.svg"} 
            alt={isMobileMenuOpen ? "Close" : "Menu"} 
            className={`menu-icon ${isMobileMenuOpen ? 'rotated' : ''}`}
          />
        </button>
      </div>
      
      <BrochureModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        onCloseAndReopenMenu={() => {
          setIsModalOpen(false);
        }}
      />
    </div>
  );
};

export default Navigation;
